import { createSelector, createSlice } from '@reduxjs/toolkit';
import { AppState } from '../store';

interface LocationState {
  location: GeolocationPosition | null;
  realtimeLocationWatcher: RealtimeLocationWatcherState;
}

export interface RealtimeLocationWatcherState {
  sharedWatchId: number | null;
  activeSubscribers: number;
}

const initialState: LocationState = {
  location: null,
  realtimeLocationWatcher: {
    sharedWatchId: null,
    activeSubscribers: 0,
  },
};

export const sharedSlices = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    incrementRealtimeLocationSubscribers: (state) => {
      state.realtimeLocationWatcher.activeSubscribers += 1;
    },
    decrementRealtimeLocationSubscribers: (state) => {
      state.realtimeLocationWatcher.activeSubscribers = Math.max(
        0,
        state.realtimeLocationWatcher.activeSubscribers - 1,
      );
    },
    setRealtimeLocationWatchId: (state, action) => {
      state.realtimeLocationWatcher.sharedWatchId = action.payload;
    },
  },
});

export const { reducer: locationReducer } = sharedSlices;

export const selectLocation = createSelector(
  (state: AppState) => state.locationReducer,
  (location) => location,
);

export const {
  setLocation,
  incrementRealtimeLocationSubscribers,
  decrementRealtimeLocationSubscribers,
  setRealtimeLocationWatchId,
} = sharedSlices.actions;
